import { render, staticRenderFns } from "./caTrait.vue?vue&type=template&id=aeccd698&scoped=true&"
import script from "./caTrait.vue?vue&type=script&lang=js&"
export * from "./caTrait.vue?vue&type=script&lang=js&"
import style0 from "./caTrait.vue?vue&type=style&index=0&id=aeccd698&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeccd698",
  null
  
)

export default component.exports